import { ArrowRight, Mail } from "lucide-react";
import { SectionWrap } from "@/components/Section";
import { CTA, CONTACT } from "@/constants/testIds";

export function FinalCTA({ onOpenContact }) {
  return (
    <SectionWrap id="contact" className="!py-32 lg:!py-40">
      <div className="relative reveal rounded-[28px] overflow-hidden border border-white/8 p-10 lg:p-16">
        {/* Banner background image */}
        <picture>
          <source srcSet="/assets/generated/cta_partner_research_banner_background.avif" type="image/avif" />
          <source srcSet="/assets/generated/cta_partner_research_banner_background.webp" type="image/webp" />
          <img
            src="/assets/generated/cta_partner_research_banner_background.png"
            alt=""
            aria-hidden
            loading="lazy"
            decoding="async"
            className="absolute inset-0 w-full h-full object-cover opacity-70"
          />
        </picture>
        {/* color wash + scrim */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(900px 500px at 80% 20%, rgba(99,102,241,0.32), transparent 60%), radial-gradient(700px 500px at 10% 90%, rgba(56,189,248,0.22), transparent 60%)",
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(90deg, rgba(2,6,23,0.85) 0%, rgba(2,6,23,0.55) 45%, rgba(2,6,23,0.25) 100%)",
          }}
        />
        <div className="absolute inset-0 dotgrid opacity-20" />

        <div className="relative max-w-3xl">
          <div className="pill">
            <span className="h-1.5 w-1.5 rounded-full bg-[#38BDF8] nb-pulse" />
            Final note
          </div>
          <h2 className="mt-6 font-display text-white text-[clamp(34px,5vw,64px)] leading-[1.05] font-medium tracking-tight">
            The next interface is{" "}
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(90deg,#38BDF8,#6366F1,#8B5CF6)",
              }}
            >
              adaptive
            </span>
            .
          </h2>
          <p className="mt-5 text-[#CBD5E1] text-[17px] max-w-2xl leading-relaxed">
            Neurobolt.AI is building toward a future where neural activity can
            be measured, modeled, and guided with personalized precision. We're
            looking for partners — researchers, clinicians, operators, and
            investors — to help shape what comes next.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <button
              data-testid={CTA.finalPrimary}
              onClick={onOpenContact}
              className="btn-glow group inline-flex items-center gap-2 pl-5 pr-4 py-3 rounded-full bg-white text-[#020617] font-semibold text-[14px] tracking-wide hover:bg-[#BFDBFE] transition-colors"
            >
              Partner with us
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </button>
            <a
              data-testid={CONTACT.mailto}
              href="mailto:contact@neurobolt.ai"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-white/15 text-white text-[14px] font-medium hover:border-[#38BDF8]/50 hover:bg-white/[0.04] transition-all"
            >
              <Mail size={16} className="text-[#38BDF8]" />
              contact@neurobolt.ai
            </a>
            <a
              data-testid={CTA.finalSecondary}
              href="/research"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full text-[#94A3B8] text-[13px] hover:text-white transition-colors"
            >
              Read the science
              <ArrowRight size={14} />
            </a>
          </div>
        </div>
      </div>
    </SectionWrap>
  );
}
